module.exports = __webpack_public_path__ + "img/kemal.dc0d06d0.jpeg";